/** Equivalent-period comparisons (e.g. Jun 1–5 vs May 1–5). */

const MS_DAY = 86400000;

export function endOfLocalDayMs(ms) {
  const d = new Date(ms);
  return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59, 999).getTime();
}

export function pctChange(current, previous) {
  if (!Number.isFinite(current) || !Number.isFinite(previous)) return null;
  if (previous === 0) return current === 0 ? 0 : null;
  return ((current - previous) / previous) * 100;
}

export function fmtPct(v) {
  if (v == null || !Number.isFinite(v)) return "—";
  return `${v > 0 ? "+" : ""}${v.toFixed(1)}%`;
}

function fmtShort(ms) {
  return new Date(ms).toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

export function monthToDateEquivalentRanges(now = Date.now()) {
  const d = new Date(now);
  const y = d.getFullYear();
  const m = d.getMonth();
  const day = d.getDate();
  const curStart = new Date(y, m, 1).getTime();
  const curEnd = endOfLocalDayMs(now);
  const prevM = m === 0 ? 11 : m - 1;
  const prevY = m === 0 ? y - 1 : y;
  const daysInPrev = new Date(prevY, prevM + 1, 0).getDate();
  const prevDay = Math.min(day, daysInPrev);
  const prevStart = new Date(prevY, prevM, 1).getTime();
  const prevEnd = new Date(prevY, prevM, prevDay, 23, 59, 59, 999).getTime();
  return {
    current: { start: curStart, end: curEnd },
    previous: { start: prevStart, end: prevEnd },
    labelCurrent: fmtShort(curStart) === fmtShort(curEnd) ? fmtShort(curEnd) : `${fmtShort(curStart)} – ${fmtShort(curEnd)}`,
    labelPrevious:
      fmtShort(prevStart) === fmtShort(prevEnd) ? fmtShort(prevEnd) : `${fmtShort(prevStart)} – ${fmtShort(prevEnd)}`,
  };
}

export function countInRange(items, getMs, start, end) {
  let n = 0;
  for (const item of items) {
    const t = getMs(item);
    if (t != null && t >= start && t <= end) n++;
  }
  return n;
}

export function compareEquivalentPeriods(current, previous, labels) {
  const growthPct = pctChange(current, previous);
  return {
    current,
    previous,
    growthPct,
    growthLabel: fmtPct(growthPct),
    comparisonText: `${labels?.current || "This period"} (${current}) vs ${labels?.previous || "prior"} (${previous})`,
  };
}
